export const SWITCH_ACTIVE_HEADER_MENU_ITEM = 'SWITCH_ACTIVE_HEADER_MENU_ITEM'
export const SET_PROJECT_VALUE = 'SET_PROJECT_VALUE'
export const SET_GROUPING_VALUE = 'SET_GROUPED_VALUE'
export const SET_TIMEZONE_VALUE = 'SET_TIMEZONE_VALUE'
export const SWITCH_INSPECT_MODE = 'SWITCH_INSPECT_MODE'